import Team from './Team.js'

//This functional component contains all the information about the project
function About() {

    return (
        <div className='body'>
            <h2 id='welcome'>You are Welcome to the home of The Mystic Creatures...</h2>
            <h4 id='detail'>
                <p>A group of soldiers on a martian travel discovered some</p>
                <p>weird creatures and brought them back down to earth.</p>
                <p>You just can't understand!</p>
            </h4>
            <br />
            <h4 id='welcome'>
                This website was created and is managed by Michael Uzochukwu Okeke
            </h4>
            <Team />
        </div>
    )
}

export default About